module.exports = __webpack_public_path__ + "media/images/Interior Window and Door Trim-e145ab1e.jpg";